module.exports = __webpack_public_path__ + "img/go5.986aaedb.png";